export function getCascadeGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        mode: {
          type: 'string',
          value: 'dhcp',
        },
      },
      commands: {
        setDHCP: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/tcu.ethernet.0.config/commands/setDHCP',
          name: 'setDHCP',
          isExecutable: false,
          params: {},
        },
        setStaticIP: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/tcu.ethernet.0.config/commands/setStaticIP',
          name: 'setStaticIP',
          isExecutable: true,
          params: {
            address: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            mask: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            defaultGateway: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            dns1: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            dns2: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
          },
        },
      },
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/tcu.ethernet.0.config',
      gatewayId: gatewaySerial,
      feature: 'tcu.ethernet.0.config',
      timestamp: '2023-03-23T11:39:31.599Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'tcu:0010;33.424.17;0010.0508.2243.0004',
              modelVersion: 'a53bf8bdc2155f8e508162beedc13fa8b4c10ede',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU300'],
              modelId: 'E3_TCU10_x07',
              status: 'online',
            },
            {
              id: 'HEMS',
              fingerprint: 'hems:0010;33.424.17;0054.0504.2243.0004',
              modelVersion: 'cbf0100043cf3b3bf12d92fbbec2d53130d3c6b9',
              name: 'Home Energy Management System',
              type: 'hems',
              roles: ['type:E3', 'type:virtual;hems'],
              modelId: 'E3_HEMS',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'sa180;7720533101318126;0020.0509.2244.0174;0002.0612.0101.0004',
              modelVersion: 'e2b093494895373d3c17d805cb8382ad4e39906e',
              name: 'Vitocal XXX-A, Release x05+',
              type: 'heating',
              roles: [
                'capability:backup;0020_HPMU_VC',
                'capability:monetization;AdvancedReport',
                'type:E3',
                'type:heatpump',
                'type:product;Vitocal_250',
                'type:cascadeV2Lead',
              ],
              modelId: 'E3_Vitocal',
              status: 'online',
            },
            {
              id: '7372760-ventilation-serial',
              fingerprint: 'sa180;7372763201661120;0016.0500.2205.0112;0016.0500.0401.0003',
              modelVersion: 'b6b3ac426dfcf1e1820b6bd09513f6b5757ca170',
              name: 'ViAir',
              type: 'ventilation',
              roles: ['type:E3', 'type:cascadeV2Lag', 'type:product;ViAir_300', 'type:ventilation'],
              modelId: 'E3_ViAir_300F_0821',
              status: 'online',
            },
            {
              id: '7372062-vitocharge-serial',
              fingerprint: 'sa180;7372062103507209;0024.0502.2207.0188;0024.0603.0101.0001',
              modelVersion: '1080bb78a37d74b2975d4dfd8208e79198228cc5',
              name: 'E3 device',
              type: 'electricityStorage',
              roles: [
                'type:E3',
                'type:cascadeV2Lag',
                'type:ess',
                'type:photovoltaic:Internal',
                'type:product;Vitocharge',
              ],
              modelId: 'E3_VitoCharge_0122',
              status: 'online',
            },
            {
              id: 'RoomControl-1',
              fingerprint: 'src:0010;33.524.8001;46.402.2240.13',
              modelVersion: '323229bd88d43dd68a70d5d017143e9abde0e8ca',
              name: 'E3_RoomControl_One_522',
              type: 'roomControl',
              roles: [
                'capability:monetization;FTDC',
                'capability:monetization;OWD',
                'capability:zigbeeCoordinator',
                'type:E3',
                'type:virtual;smartRoomControl',
              ],
              modelId: 'E3_RoomControl_One_522',
              status: 'online',
            },
            {
              id: 'zigbee-84fd27fffed06d66',
              fingerprint: 'zigbee:RadiatorActuator;33.424.17;1;1',
              modelVersion: 'f80d3234a8edac544ced64d1da9781acd40377b2',
              name: 'E3_RadiatorActuator_One_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:actuator', 'type:radiator', 'type:smartRoomDevice'],
              modelId: 'E3_RadiatorActuator',
              status: 'online',
            },
            {
              id: 'zigbee-804b50fffea21166',
              fingerprint: 'zigbee:RoomSensor;33.424.17;1;4',
              modelVersion: 'b36c8abff45e84684e0e1cab5cb32255c3b96425',
              name: 'E3_RoomSensor_Four_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:climateSensor', 'type:sensor', 'type:smartRoomDevice'],
              modelId: 'E3_RoomSensor',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1',
              fingerprint: 'zigbee:FloorHeatingCircuitDistributorBox;33.424.17;1;5',
              modelVersion: 'e72f6f767819f4aae5f07369aaceefa418447ee1',
              name: 'E3_FloorHeatingCircuitDistributorBox_Five_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:actuator', 'type:fhtMain', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitDistributorBox',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1-1',
              fingerprint: 'zigbee:FloorActuatorNormalyClosed;33.424.17;1;6',
              modelVersion: '9ab1fcf9e568f59b2658179ca73ff361fab5bbc8',
              name: 'E3_FloorHeatingCircuitChannel_Six_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:fhtChannel', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitChannel',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1-2',
              fingerprint: 'zigbee:FloorActuatorNormalyOpen;33.424.17;1;7',
              modelVersion: '790aee6ffaa604e9a6bbb32d86baad1957a07263',
              name: 'E3_FloorHeatingCircuitChannel_Seven_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:fhtChannel', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitChannel',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2023-03-24T00:48:06.420Z',
      isEnabled: true,
      isReady: true,
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2023-03-24T10:05:58.926Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/battery.overview',
      feature: 'battery.overview',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        power: {
          value: 0.201,
          type: 'number',
          unit: 'kilowatt',
        },
        state: {
          value: 'charge',
          type: 'string',
        },
      },
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2023-03-24T10:05:58.926Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/photovoltaic.overview',
      feature: 'photovoltaic.overview',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        power: {
          value: 1190,
          type: 'number',
          unit: 'watt',
        },
        status: {
          value: 'production',
          type: 'string',
        },
      },
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2023-03-24T10:05:58.926Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/thermal.cockpit',
      feature: 'thermal.cockpit',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        thermalOutput: {
          value: 0,
          type: 'number',
          unit: 'kilowatt',
        },
        electricityInput: {
          value: 0,
          type: 'number',
          unit: 'watt',
        },
      },
    },
  ];
}

export function getVitoden300GatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        value: {
          value: 'Europe/Berlin',
          type: 'string',
        },
      },
      commands: {
        setTimezone: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/gateway.timezone/setTimezone',
          name: 'setTimezone',
          isExecutable: true,
          params: {
            value: {
              type: 'string',
              required: true,
              constraints: {},
            },
          },
        },
      },
      gatewayId: gatewaySerial,
      feature: 'gateway.timezone',
      timestamp: '2020-04-30T06:53:27.004Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.timezone',
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2020-04-30T06:53:27.004Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -67,
        },
        channel: {
          type: 'number',
          value: 5,
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2020-04-30T07:46:12.989Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
    },
    {
      properties: {},
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway',
      timestamp: '2020-04-30T06:53:26.784Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway',
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: '0',
              fingerprint: 'gg:20,gk:cb,si:201,esi:1',
              modelId: 'VScotHO1_200_01',
              modelVersion: 'f67fe3c1f072baa4fe36f65dd4410332ecef8d2c',
              name: 'Vitodens 300 with HO2B',
              type: 'heating',
              status: 'online',
            },
            {
              id: 'gateway',
              fingerprint: 'gw:hb2,mj:2,mi:22,p:0',
              modelId: 'Heatbox2_SRC',
              modelVersion: '3e5d28b14dee4e505bb2c3928752791269eab6cc',
              name: 'Heatbox 2 SRC, Vitoconnect',
              type: 'vitoconnect',
              status: 'online',
            },
            {
              id: 'RoomControl-1',
              fingerprint: 'src:0010;33.524.8001;46.402.2240.13',
              modelVersion: '323229bd88d43dd68a70d5d017143e9abde0e8ca',
              name: 'E3_RoomControl_One_522',
              type: 'roomControl',
              roles: [
                'capability:monetization;FTDC',
                'capability:monetization;OWD',
                'capability:zigbeeCoordinator',
                'type:E3',
                'type:virtual;smartRoomControl',
              ],
              modelId: 'E3_RoomControl_One_522',
              status: 'online',
            },
            {
              id: 'zigbee-84fd27fffed06d66',
              fingerprint: 'zigbee:RadiatorActuator;33.424.17;1;1',
              modelVersion: 'f80d3234a8edac544ced64d1da9781acd40377b2',
              name: 'E3_RadiatorActuator_One_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:actuator', 'type:radiator', 'type:smartRoomDevice'],
              modelId: 'E3_RadiatorActuator',
              status: 'online',
            },
            {
              id: 'zigbee-804b50fffea21166',
              fingerprint: 'zigbee:RoomSensor;33.424.17;1;4',
              modelVersion: 'b36c8abff45e84684e0e1cab5cb32255c3b96425',
              name: 'E3_RoomSensor_Four_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:climateSensor', 'type:sensor', 'type:smartRoomDevice'],
              modelId: 'E3_RoomSensor',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1',
              fingerprint: 'zigbee:FloorHeatingCircuitDistributorBox;33.424.17;1;5',
              modelVersion: 'e72f6f767819f4aae5f07369aaceefa418447ee1',
              name: 'E3_FloorHeatingCircuitDistributorBox_Five_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:actuator', 'type:fhtMain', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitDistributorBox',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1-1',
              fingerprint: 'zigbee:FloorActuatorNormalyClosed;33.424.17;1;6',
              modelVersion: '9ab1fcf9e568f59b2658179ca73ff361fab5bbc8',
              name: 'E3_FloorHeatingCircuitChannel_Six_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:fhtChannel', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitChannel',
              status: 'online',
            },
            {
              id: 'zigbee-000b57fffeca9dc1-2',
              fingerprint: 'zigbee:FloorActuatorNormalyOpen;33.424.17;1;7',
              modelVersion: '790aee6ffaa604e9a6bbb32d86baad1957a07263',
              name: 'E3_FloorHeatingCircuitChannel_Seven_522',
              type: 'zigbee',
              roles: ['type:E3', 'type:fhtChannel', 'type:smartRoomDevice'],
              modelId: 'E3_FloorHeatingCircuitChannel',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2020-04-30T07:11:38.389Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
    },
  ];
}

export function getVitocal252GatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'tcu:0010;33.424.17;0010.0508.2243.0004',
              modelVersion: 'a53bf8bdc2155f8e508162beedc13fa8b4c10ede',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU300'],
              modelId: 'E3_TCU10_x07',
              status: 'online',
            },
            {
              id: 'HEMS',
              fingerprint: 'hems:0010;33.424.17;0054.0504.2243.0004',
              modelVersion: 'cbf0100043cf3b3bf12d92fbbec2d53130d3c6b9',
              name: 'Home Energy Management System',
              type: 'hems',
              roles: ['type:E3', 'type:virtual;hems'],
              modelId: 'E3_HEMS',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'sa180;7720533101318126;0020.0509.2244.0174;0002.0612.0101.0004',
              modelVersion: 'e2b093494895373d3c17d805cb8382ad4e39906e',
              name: 'Vitocal XXX-A, Release x05+',
              type: 'heating',
              roles: [
                'capability:backup;0020_HPMU_VC',
                'type:E3',
                'type:heatpump',
                'type:product;Vitocal_250',
              ],
              modelId: 'E3_Vitocal',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2023-03-24T00:48:06.420Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -66,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2022-10-09T08:07:03.797Z',
      isEnabled: true,
      isReady: true,
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2022-10-09T08:06:57.841Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/thermal.cockpit',
      feature: 'thermal.cockpit',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        thermalOutput: {
          value: 0,
          type: 'number',
          unit: 'kilowatt',
        },
        electricityInput: {
          value: 0,
          type: 'number',
          unit: 'kilowatt',
        },
      },
    },
  ];
}

export function getVitocal222SGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'gw:hb2,mj:2,mi:48,p:9',
              modelVersion: 'a78293523364746abfb6e664369df58560f16a88',
              name: 'Heatbox 2 SRC, Vitoconnect',
              type: 'vitoconnect',
              roles: ['type:gateway;VitoconnectOpto1', 'type:hb2', 'type:E3'],
              modelId: 'Heatbox2_SRC',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'gg:20,gk:4d,si:65,esi:65535',
              modelVersion: '3654a3956dc10f17f2e84b7c6d6c185f41a4a2dd',
              name: 'Vitocalxxx-S mit Vitotronic 200 (Typ WO1C)',
              type: 'heating',
              roles: ['type:heatpump', 'type:E3', 'type:product;CU401B'],
              modelId: 'CU401B_S',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2023-03-22T02:17:51.586Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -73,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2023-03-23T11:12:50.149Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2023-03-22T02:17:51.680Z',
      isEnabled: true,
      isReady: true,
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2023-03-23T16:10:14.262Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/thermal.cockpit',
      feature: 'thermal.cockpit',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        thermalOutput: {
          value: 2.664,
          type: 'number',
          unit: 'kilowatt',
        },
        electricityInput: {
          value: 2.664,
          type: 'number',
          unit: 'kilowatt',
        },
      },
    },
  ];
}

export function getVitodens200GatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: '0',
              fingerprint: '0019_wifi;7722311001902120;0002.0515.2020.0456;0002.0603.0102.0002',
              modelVersion: 'b049a2363d850a422443b89f4949efc001a36f76',
              name: 'Vitodens Two Hundred E3, Release 0620',
              type: 'heating',
              roles: [
                'capability:backup;0002_HMU_VD2',
                'capability:monetization;AdvancedReport',
                'type:E3',
                'type:boiler',
                'type:product;Vitodens_200',
              ],
              modelId: 'E3_Vitodens_200_0620',
              status: 'online',
            },
            {
              id: 'gateway',
              fingerprint: 'tcu:0019;33.524.8001;0019.0506.2244.0004',
              modelVersion: 'b5b08651f54afb5a95033bae5d6cfd8ac3dc853c',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU200'],
              modelId: 'E3_TCU19_x05',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2023-03-28T06:13:27.951Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -65,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2023-03-28T08:32:17.283Z',
      isEnabled: true,
      isReady: true,
    },
  ];
}

export function getVitocal200SGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        strength: {
          type: 'number',
          value: -37,
        },
        channel: {
          type: 'number',
          value: 0,
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2020-02-26T07:23:47.447Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'gw:hb2,mj:1,mi:4,p:5',
              modelId: 'Heatbox2',
              modelVersion: 'aa55a51d351e262edf76f774e0df510c2d93f042',
              name: 'Heatbox 2, Vitoconnect',
              type: 'vitoconnect',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'gg:20,gk:4d,si:25,esi:65535',
              modelId: 'CU401B_S',
              modelVersion: '757049104d22dc9f5d6a0542bd6fd0f21c6d93fc',
              name: 'Vitocalxxx-S mit Vitotronic 200 (Typ WO1C)',
              type: 'heating',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2020-02-25T21:19:44.173Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2020-02-25T21:19:44.238Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
    },
    {
      properties: {},
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway',
      timestamp: '2020-02-25T21:19:44.086Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway',
    },
    {
      properties: {
        value: {
          value: 'Europe/Warsaw',
          type: 'string',
        },
      },
      commands: {
        setTimezone: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/gateway.timezone/setTimezone',
          name: 'setTimezone',
          isExecutable: true,
          params: {
            value: {
              type: 'string',
              required: true,
              constraints: {},
            },
          },
        },
      },
      gatewayId: gatewaySerial,
      feature: 'gateway.timezone',
      timestamp: '2020-02-25T21:19:44.264Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.timezone',
    },
  ];
}

export function getVitovalorPTSGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: '0',
              fingerprint: 'sa180;7470092901376111;0002.0511.1842.0263;0002.0500.0600.0001',
              modelId: 'E3_Vitovalor_27/E3_Dictionary',
              modelVersion: '4f848356bd3904ed672efe683d801b0c6fcdc215',
              name: 'Vitovalor E3, Release CW27',
              type: 'heating',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2020-02-26T04:20:58.460Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -45,
        },
        channel: {
          type: 'number',
          value: 0,
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2020-02-26T04:21:33.936Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
    },
    {
      properties: {},
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway',
      timestamp: '2020-02-26T04:20:54.522Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway',
    },
  ];
}

export function getVitodens343FGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        strength: {
          type: 'number',
          value: -68,
        },
        channel: {
          type: 'number',
          value: 1,
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2020-02-26T06:59:17.951Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'gw:hb1,mj:2,mi:3,p:3',
              modelId: 'Heatbox1',
              modelVersion: 'cbcca1402f4567a88f456d99b928d9a00ba2c9e6',
              name: 'Heatbox 1, Vitoconnect',
              type: 'vitoconnect',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'gg:20,gk:cb,si:200,esi:1',
              modelId: 'VScotHO1_200_01',
              modelVersion: '0d17778ef571be22535b6d8710957027cb39ea5e',
              name: 'Vitodens 300 with HO2B',
              type: 'heating',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2020-02-26T02:38:34.842Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2020-02-26T02:38:34.948Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
    },
    {
      properties: {},
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway',
      timestamp: '2020-02-26T02:38:34.403Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway',
    },
  ];
}

export function getVitodens100WGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        strength: {
          type: 'number',
          value: -57,
        },
        channel: {
          type: 'number',
          value: 0,
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2020-02-26T06:40:07.416Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: '0',
              fingerprint: 'cp:ot,mid:21,type:09,version:69',
              modelId: 'OT_Heating_System',
              modelVersion: 'a33659cb5ed8c005e47573d860798eef273471ac',
              name: 'OT_Heating_System_69',
              type: 'heating',
              status: 'online',
            },
            {
              id: 'gateway',
              fingerprint: 'gw:hb2,mj:1,mi:4,p:5',
              modelId: 'Heatbox2',
              modelVersion: 'aa55a51d351e262edf76f774e0df510c2d93f042',
              name: 'Heatbox 2, Vitoconnect',
              type: 'vitoconnect',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2020-02-23T02:17:29.236Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2020-02-23T02:17:29.260Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
    },
    {
      properties: {},
      commands: {},
      gatewayId: gatewaySerial,
      feature: 'gateway',
      timestamp: '2020-02-23T02:17:28.870Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway',
    },
    {
      properties: {
        value: {
          value: 'Europe/Berlin',
          type: 'string',
        },
      },
      commands: {
        setTimezone: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/gateway.timezone/setTimezone',
          name: 'setTimezone',
          isExecutable: true,
          params: {
            value: {
              type: 'string',
              required: true,
              constraints: {},
            },
          },
        },
      },
      gatewayId: gatewaySerial,
      feature: 'gateway.timezone',
      timestamp: '2020-02-23T02:17:29.265Z',
      isEnabled: true,
      isReady: true,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.timezone',
    },
  ];
}

export function getVitochargeGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        mode: {
          type: 'string',
          value: 'dhcp',
        },
      },
      commands: {
        setDHCP: {
          uri:
            'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/tcu.ethernet.0.config/commands/setDHCP',
          name: 'setDHCP',
          isExecutable: false,
          params: {},
        },
        setStaticIP: {
          uri:
            'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/tcu.ethernet.0.config/commands/setStaticIP',
          name: 'setStaticIP',
          isExecutable: true,
          params: {
            address: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            mask: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            defaultGateway: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            dns1: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
            dns2: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
              },
            },
          },
        },
      },
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/tcu.ethernet.0.config',
      gatewayId: gatewaySerial,
      feature: 'tcu.ethernet.0.config',
      timestamp: '2022-10-11T12:01:07.187Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'tcu:0010;33.424.17;0010.0508.2238.0001',
              modelVersion: 'e657fca9e74144841922011a0ba06641938238cd',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU300'],
              modelId: 'E3_TCU10_x07',
              status: 'online',
            },
            {
              id: 'HEMS',
              fingerprint: 'hems:0010;33.424.17;0054.0504.2238.0001',
              modelVersion: 'ae9ae79530e24d95dd8b50938470fe533ea019df',
              name: 'Home Energy Management System',
              type: 'hems',
              roles: ['type:E3', 'type:virtual;hems'],
              modelId: 'E3_HEMS',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'sa180;7372956201325202;0024.0502.2207.0188;0024.0603.0101.0001',
              modelVersion: 'a84ec6ca2f85d0f9b3b6f9a366b1cb6aa173c930',
              name: 'E3 device',
              type: 'electricityStorage',
              roles: [
                'type:E3',
                'type:ess',
                'type:photovoltaic;Internal',
                'type:product;Vitocharge',
              ],
              modelId: 'E3_VitoCharge_0122',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2022-10-11T12:01:07.192Z',
      isEnabled: true,
      isReady: true,
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2022-10-11T16:29:56.247Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/battery.overview',
      feature: 'battery.overview',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        power: {
          value: 0.123,
          type: 'number',
          unit: 'kilowatt',
        },
        state: {
          value: 'discharge',
          type: 'string',
        },
      },
    },
    {
      apiVersion: 1,
      isEnabled: true,
      isReady: true,
      timestamp: '2022-10-11T16:29:56.247Z',
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/photovoltaic.overview',
      feature: 'photovoltaic.overview',
      gatewayId: gatewaySerial,
      commands: {},
      properties: {
        power: {
          value: 0,
          type: 'number',
          unit: 'watt',
        },
        status: {
          value: 'ready',
          type: 'string',
        },
      },
    },
  ];
}

export function getVitoligno300CGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'gw:hb2,mj:2,mi:48,p:4',
              modelVersion: '3b8b858c2184e5b55330fb1c0e8f8a0911211b39',
              name: 'Heatbox 2 SRC, Vitoconnect',
              type: 'vitoconnect',
              roles: ['type:gateway;VitoconnectOpto1', 'type:hb2', 'type:legacy'],
              modelId: 'Heatbox2_SRC',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'gg:20,gk:34,si:24,esi:65535',
              modelVersion: 'f4121dfdf875f3b8847f8773d1a8607d6c763e56',
              name: 'Ecotronic',
              type: 'heating',
              roles: ['type:boiler', 'type:legacy', 'type:renewable'],
              modelId: 'Ecotronic',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2022-08-11T04:30:27.389Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        status: {
          type: 'string',
          value: 'OK',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.bmuconnection',
      gatewayId: gatewaySerial,
      feature: 'gateway.bmuconnection',
      timestamp: '2022-08-11T11:44:08.829Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -78,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2022-08-12T09:03:32.028Z',
      isEnabled: true,
      isReady: true,
    },
  ];
}

export function getVitoairGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: '0',
              fingerprint: '0041_tcu;7892763-device-serial;0016.0500.2228.0133;0000.0000.0000.0000',
              modelVersion: '4fff75a582ca49255b630a85b7f54cd71d48d850',
              name: 'ViAir',
              type: 'ventilation',
              roles: ['type:E3', 'type:product;ViAir_300', 'type:ventilation'],
              modelId: 'E3_ViAir_300F_0821',
              status: 'online',
            },
            {
              id: 'TCU',
              fingerprint: 'tcu:0041;33.322.4;41.504.2222.43',
              modelVersion: 'cb0ad204435e5b17d3a1fbb3b3631c99247e8190',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU100'],
              modelId: 'E3_TCU41_x04',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2022-11-02T20:32:36.861Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -60,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2022-11-24T06:37:18.653Z',
      isEnabled: true,
      isReady: true,
    },
  ];
}

export function getVitosetAquaGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        devices: {
          type: 'DeviceList',
          value: [
            {
              id: 'gateway',
              fingerprint: 'tcu:0010;33.321.3;0010.0507.2224.0005',
              modelVersion: 'e657fca9e74144841922011a0ba06641938238cd',
              name: 'TCU',
              type: 'tcu',
              roles: ['capability:zigbeeCoordinator', 'type:E3', 'type:gateway;TCU300'],
              modelId: 'E3_TCU10_x07',
              status: 'online',
            },
            {
              id: '0',
              fingerprint: 'sa180;7720485101005127;0020.0504.2223.0156;0020.0610.0301.0004',
              modelVersion: 'bddfdf29a7aa174a28b21e977fd033290d3eddba',
              name: 'Vitocal XXX-A, Release x04+',
              type: 'heating',
              roles: [
                'capability:backup;0020_HPMU_VC',
                'type:E3',
                'type:cascadeV2Lead',
                'type:heatpump',
                'type:product;Vitocal_250',
              ],
              modelId: 'E3_Vitocal',
              status: 'online',
            },
            {
              id: 'VitosetAqua',
              fingerprint: '0041_tcu;0000000000000000;0079.0500.2237.1060;0079.0500.0738.2461',
              modelVersion: '7454384b304d98e0767a460f7012f42c10a5d730',
              name: 'Vitoset',
              type: 'WaterSoftener',
              roles: [
                'type:E3',
                'type:product;VitosetAqua',
                'type:water;leakageDetection',
                'type:water;softener',
              ],
              modelId: 'E3_VitosetAqua_1121',
              status: 'online',
            },
            {
              id: 'ventilation',
              fingerprint: '0041_tcu;0000000000000000;0079.0500.2237.1060;0079.0500.0738.2461',
              modelVersion: '7454384b304d98e0767a460f7012f42c10a5d730',
              name: 'ventilation',
              type: 'ventilation',
              roles: ['type:E3', 'type:cascadeV2Lag', 'type:product;ViAir_300', 'type:ventilation'],
              modelId: 'ViAir_300',
              status: 'online',
            },
          ],
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.devices',
      gatewayId: gatewaySerial,
      feature: 'gateway.devices',
      timestamp: '2022-10-05T14:52:14.563Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        strength: {
          type: 'number',
          value: -55,
          unit: '',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.wifi',
      gatewayId: gatewaySerial,
      feature: 'gateway.wifi',
      timestamp: '2022-10-06T09:56:55.583Z',
      isEnabled: true,
      isReady: true,
    },
  ];
}

export function getDefaultGatewayFeatures(installationId: number, gatewaySerial: string) {
  return [
    {
      properties: {
        mode: {
          type: 'string',
          value: 'wifi',
        },
      },
      commands: {},
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.mode',
      gatewayId: gatewaySerial,
      feature: 'gateway.mode',
      timestamp: '2022-10-05T18:58:24.468Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        online: {
          type: 'boolean',
          value: true,
        },
      },
      commands: {
        reboot: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/gateway.status/commands/reboot',
          name: 'reboot',
          isExecutable: true,
          params: {},
        },
      },
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.status',
      gatewayId: gatewaySerial,
      feature: 'gateway.status',
      timestamp: '2022-10-05T14:50:28.982Z',
      isEnabled: true,
      isReady: true,
    },
    {
      properties: {
        version: {
          type: 'string',
          value: '0507.2224.0005',
        },
        updateStatus: {
          type: 'string',
          value: 'idle',
        },
      },
      commands: {
        update: {
          uri:
            'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
            installationId +
            '/gateways/' +
            gatewaySerial +
            '/features/gateway.firmware/commands/update',
          name: 'update',
          isExecutable: true,
          params: {
            url: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '((ftp|https?):\\/)?\\/?([^:\\/\\s]+)(:[0-9]+)?((\\/\\w+)*\\/)([\\w\\-\\.]+[^#?\\s]+)(.*)?',
              },
            },
            version: {
              type: 'string',
              required: true,
              constraints: {
                regEx:
                  '^([0-9]+)\\.([0-9]+)\\.([0-9]+)((\\.[0-9]+)?)(?:(-[0-9A-Za-z-]+(?:\\.[0-9A-Za-z-]+)*))?(?:\\+[0-9A-Za-z-\\-.]+)?$',
              },
            },
          },
        },
      },
      apiVersion: 1,
      uri:
        'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
        installationId +
        '/gateways/' +
        gatewaySerial +
        '/features/gateway.firmware',
      gatewayId: gatewaySerial,
      feature: 'gateway.firmware',
      timestamp: '2022-10-05T18:58:25.093Z',
      isEnabled: true,
      isReady: true,
    },
  ];
}

export function getRemoteDiagnosticsFeature(installationId: number, gatewaySerial: string) {
  return {
    properties: {
      status: {
        type: 'string',
        value: 'ready',
      },
      webSocketUrl: {
        type: 'string',
        value:
          'wss://remote-diag-integration-1.viessmann-platform.io/v1/connect?token=61bb5103-9135-4dc0-a9bf-067921282e69&role=technician',
      },
    },
    commands: {
      open: {
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/features/gateway.remoteDiagnostics/commands/open',
        name: 'open',
        isExecutable: false,
        params: {},
      },
      close: {
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/features/gateway.remoteDiagnostics/commands/close',
        name: 'close',
        isExecutable: true,
        params: {},
      },
    },
    apiVersion: 1,
    uri:
      'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
      installationId +
      '/gateways/' +
      gatewaySerial +
      '/features/gateway.remoteDiagnostics',
    gatewayId: gatewaySerial,
    feature: 'gateway.remoteDiagnostics',
    timestamp: '2022-01-17T14:39:23.979Z',
    isEnabled: true,
    isReady: true,
  };
}
